import QuestionNarcissism from "../components/QuestionNarcissism";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from 'react-router-dom';

function App() {
    const navigate = useNavigate();
    const questions = [
        { answerFalse: "När människor ger mig komplimanger blir jag ibland generad.", answerTrue: "Jag vet att jag är duktig eftersom andra ofta säger det till mig." },
        { answerFalse: "Jag föredrar att smälta in i mängden.", answerTrue: "Jag tycker om att stå i centrum för uppmärksamheten." },
        { answerFalse: "Jag är varken bättre eller sämre än de flesta andra.", answerTrue: "Jag ser mig själv som en speciell person."},
        { answerFalse: "Jag har inget emot att följa order.", answerTrue: "Jag tycker om att ha makt över andra människor."},
        { answerFalse: "Jag känner mig obekväm när jag märker att jag manipulerar andra.", answerTrue: "Jag tycker att det är lätt att manipulera människor."},
        { answerFalse: "Jag brukar få den respekt jag förtjänar.", answerTrue: "Jag kräver att få den respekt jag anser att jag förtjänar."},
        { answerFalse: "Jag försöker att inte visa upp mig.", answerTrue: "Jag gillar att visa upp mig när jag får chansen."},
        { answerFalse: "Ibland är jag osäker på vad jag gör.", answerTrue: "Jag vet alltid vad jag gör."},
        { answerFalse: "Ibland är jag bra på att berätta historier.", answerTrue: "Alla tycker om att lyssna på mina historier."},
        { answerFalse: "Jag tycker om att hjälpa andra människor.", answerTrue: "Jag ställer höga krav på andra."},
        { answerFalse: "Jag känner mig obekväm när all uppmärksamhet är riktad mot mig.", answerTrue: "Jag gillar verkligen att stå i centrum."},
        { answerFalse: "Att ha auktoritet betyder inte så mycket för mig.", answerTrue: "Folk verkar alltid erkänna min auktoritet."},
        { answerFalse: "Jag hoppas att jag kommer att bli framgångsrik.", answerTrue: "Jag kommer att bli en stor/framstående person."},
        { answerFalse: "Folk tror ibland på det jag säger till dem.", answerTrue: "Jag kan få vem som helst att tro på vad jag vill."},
        { answerFalse: "Jag kan lära mig mycket av andra människor.", answerTrue: "Jag är mer kompetent än de flesta andra människor."},
        { answerFalse: "Jag är som de flesta andra.", answerTrue: "Jag är en exceptionell person."}
    ];

    const wrapperRef = useRef();
    const lastSentHeight = useRef(0);

    // Store selected answers by index, and total score
    const [selectedAnswers, setSelectedAnswers] = useState(Array(questions.length).fill(null));
    const [total, setTotal] = useState(0);
    const [error, setError] = useState('');
    const [isSubmitted, setIsSubmitted] = useState(false);

     const sendHeight = useCallback(() => {
        const newHeight = wrapperRef.current?.scrollHeight;
        if (
            newHeight &&
            Math.abs(newHeight - lastSentHeight.current) > 20
        ) {
            window.parent.postMessage(
                {
                    type: "setHeight",
                    height: newHeight,
                    isSubmitted: isSubmitted,
                },
                "*"
            );
            lastSentHeight.current = newHeight;
        }
    }, [isSubmitted]);

    useEffect(() => {
        function handleResize() {
            sendHeight();
        }
        window.addEventListener('resize', handleResize);
        // Send initial height
        sendHeight();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [sendHeight]);

    // Handler for when an answer is selected
    const handleAnswer = (index, value) => {
        setSelectedAnswers((prev) => {
            const updated = [...prev];
            updated[index] = value;
            // Calculate new total
            const newTotal = updated.reduce((sum, v) => sum + (v === 1 ? 1 : 0), 0);
            setTotal(newTotal);
            return updated;
        });
    };

    const handleSubmit = () => {
        if (selectedAnswers.includes(null)) {
            setError('Vänligen svara på alla frågor innan du tolkar dina svar.');
            return;
        }
        setIsSubmitted(true);
        localStorage.setItem('narcissismScore', total);
        setTimeout(() => {
            navigate("/narcissismResult");
        }, 300);
    }

    return (
        <div className="questionnaire-narcissism" ref={wrapperRef}>
            {questions.map((answer, index) => (
                <QuestionNarcissism
                    answer={answer}
                    index={index}
                    key={index}
                    onSelect={(val) => handleAnswer(index, val)}
                    selected={selectedAnswers[index]}
                />
            ))}
            {error && <p className="error">{error}</p>}
            <div className='submit-container'>
                <button onClick={handleSubmit} className="submit-button">
                    Tolka mina svar
                </button>
            </div>
        </div>
    );
}

export default App;